export const borderColor = "#E3E3E3";
export const inputBackground = "#EDEDED";
export const tabsBackground = "#F5F5F5";
export const error = "#C9312D";
export const secondary = "#2B718D";
export const warning = "#FFAE2C";
export const success = "#449D43";
export const google = "#DB4C3F";
export const facebook = "#3B5898";

export function lightenDarkenColor(col: string, amt: number) {
  let usePound = false;

  if (col[0] === "#") {
    col = col.slice(1);
    usePound = true;
  }

  let num = parseInt(col, 16);

  let r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  let b = ((num >> 8) & 0x00ff) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  let g = (num & 0x0000ff) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
}

export function darkenLightColor(color: string, amount: number) {
  return color
    .replace(/^#/, "")
    .replace(/../g, (color) =>
      (
        "0" +
        Math.min(255, Math.max(0, parseInt(color, 16) - amount)).toString(16)
      ).substr(-2)
    );
}
